"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerManagerSystem = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
const ClientPlayer_1 = require("../../Assemblages/ClientPlayer");
const types_1 = require("../../../Shared/types");
const Component_1 = require("../NPCMovement/Component");
class PlayerManagerSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.PLAYER_MANAGER);
    }
    onClear() { }
    onStart() {
        return __awaiter(this, void 0, void 0, function* () {
            this.initializePlayer(this.globals.gameStateData);
        });
    }
    initializePlayer(gameState) {
        //console.error('game state player', { ...gameState.position}, 'but defa', START_POSITIONS.player)
        this.globals.clientPlayer = this.initializeEntity(new ClientPlayer_1.ClientPlayer(), gameState);
        this.globals.clientPlayer.once('gameobject-ready', gameObject => {
            if (this.$api.needsTutorial()) {
                this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_MOVEMENT).disabled = true;
                this.globals.clientPlayer.addComponent(new Component_1.NPCMovementComponent(types_1.GameValues.PlayerSpeed, this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_ANIMATION).skeleton));
            }
            else {
                this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_MOVEMENT).disabled = false;
            }
            this.dispatchAllLocal({
                type: Constants_1.MESSAGES.CLIENT_PLAYER_ENTITY_INITIALIZED,
                data: this.globals.clientPlayer,
            });
        });
    }
    onLocalMessage(message) {
        switch (message.type) {
            case Constants_1.MESSAGES.FINISHED_TUTORIAL:
                this.globals.clientPlayer.getComponent(Constants_1.SYSTEMS.PLAYER_MOVEMENT).disabled = false;
                this.globals.clientPlayer.removeComponent(Constants_1.SYSTEMS.NPC_MOVEMENT);
                break;
        }
    }
    onPeerMessage(peerId, message) {
    }
    onServerMessage(message) {
    }
    update(delta) {
    }
}
exports.PlayerManagerSystem = PlayerManagerSystem;
//# sourceMappingURL=module.js.map